import React from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Typography,
  Button,
} from "@mui/material";
import CloseIcon from "../assets/X.svg";
import "./CustomDialog.css";

interface CustomDialogProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  imageSrc: string;
  content: string;
  buttonText: string;
  onButtonClick: () => void;
  showCloseIcon?: boolean;
}

const CustomDialog: React.FC<CustomDialogProps> = ({
  open,
  onClose,
  imageSrc,
  content,
  buttonText,
  onButtonClick,
  showCloseIcon = true,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        className: "dialog-paper",
        style: {
          width: "829px", // Updated width
          height: "422px", // Updated height
        },
      }}
    >
      <DialogTitle className="dialog-title">
        {showCloseIcon && (
          <IconButton
            onClick={onClose}
            aria-label="close"
            className="close-button"
          >
            <img src={CloseIcon} alt="close" className="close-icon" />
          </IconButton>
        )}
        <Divider
          sx={{
            margin: "-15px 0",
          }}
        />
      </DialogTitle>
      <DialogContent className="dialog-content">
        <img src={imageSrc} alt="dialog-img" className="dialog-image" />
        <Typography className="dialog-text">{content}</Typography>
        <Button
          sx={{
            borderRadius: "5px",
            width: "537px", // Set a specific width for the button
            maxWidth: "80%",
          }}
          variant="contained"
          color="primary"
          onClick={onButtonClick}
        >
          {buttonText}
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default CustomDialog;
